import {Component, inject, OnInit} from '@angular/core'
import {Router} from '@angular/router'

@Component({
  selector: 'spb-reset',
  template: ''
})
export class ResetComponent implements OnInit {
  private readonly router = inject(Router)

  ngOnInit(): void {
    this.router.navigate(['/']).then()
  }

}
